import { render, staticRenderFns } from "./XContentCard.vue?vue&type=template&id=38c9d3d9"
import script from "./XContentCard.vue?vue&type=script&lang=js"
export * from "./XContentCard.vue?vue&type=script&lang=js"
import style0 from "./XContentCard.vue?vue&type=style&index=0&id=38c9d3d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports